import React, { useEffect, useState } from 'react';
import './style.css';
import { MindMapContext } from '../../Context/contex';
import { getWatermarkData } from '../../Utils/helper';

const WaterMark = () => {
    const [watermarkData, setWatermarkData] = useState(null);
    const { userInfo } = MindMapContext();

    useEffect(() => {
        let isMounted = true;
        const loadData = async () => {
            const data = await getWatermarkData();
            if (isMounted) setWatermarkData(data);
        };
        loadData();
        return () => { isMounted = false; };
    }, []);

    const {
        location = { lat: 'N/A', lng: 'N/A' },
        ip = 'N/A',
        currentDateTime = 'N/A'
    } = watermarkData || {};

    return (
        <div className="watermark-style">
            <div>User: {userInfo?.name || 'N/A'}</div>
            <div>Location: {location.lat}, {location.lng}</div>
            <div>IP: {ip}</div>
            <div>Time: {currentDateTime}</div>
        </div>
    );
};

export default WaterMark;
